var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLava(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "25px",
    viewBox: "0 0 147 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "[Microtica-2021]new-Pricing-page",
    transform: "translate(-622.000000, -937.000000)",
    fill: "#B2B2B2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(401.000000, 925.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(221.801111, 12.971458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.5107959,19.4236537 C72.6538477,20.9824273 70.8943229,22.4555866 69.0728013,23.9877902 L56.5760419,9.07611244 C54.6275747,6.75566525 53.2636478,6.75271302 51.3476551,9.04068576 C47.2145431,13.9768024 43.081431,18.9070146 38.8213734,23.984838 L33.3833789,19.4295581 L40.3683382,11.057054 C42.3551842,8.68051457 44.3567913,6.31873626 46.3377329,3.93629239 C50.6715961,-1.29209434 57.1664864,-1.30685546 61.5210152,3.90972238 L74.5107959,19.4236537 Z",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.975378,4.55038427 L74.3484236,0.018722142 L84.6221593,12.2881605 C85.3808806,13.1915407 86.1307452,14.1034823 86.8894665,15.0071577 C88.7464146,17.2269341 90.207765,17.2213249 92.0381432,15.0278233 C95.9135261,10.3810245 99.7948136,5.74219665 103.68171,1.11104461 C103.962171,0.777443424 104.257394,0.458603352 104.626422,0.0423399251 L110.028989,4.59171539 L102.415207,13.699323 C100.457883,16.0374835 98.5359857,18.4051663 96.5314264,20.7019957 C92.6935366,25.0919511 86.1986463,25.1067122 82.4227532,20.7019957 C78.0180367,15.529406 73.6989346,10.3101711 69.3355492,5.09949773 C69.2174603,4.95483881 69.1259413,4.78951433 68.975378,4.55038427",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.576617,19.4176016 L140.150431,23.9817382 C138.969542,22.5708709 137.788653,21.2069439 136.64939,19.8486261 C133.651408,16.2607897 130.652244,12.6759054 127.650719,9.09367816 C125.657969,6.71713874 124.323859,6.73189985 122.3131,9.13796151 C118.557873,13.6256355 114.805893,18.1147856 111.056274,22.6062975 C110.687247,23.049131 110.294601,23.4739558 109.857967,23.9731767 C108.030246,22.4377256 106.3153,20.9881842 104.463961,19.4412194 C105.553626,18.1189187 106.592513,16.837654 107.649409,15.5738074 C110.896854,11.6919295 114.1443,7.79794754 117.415363,3.93319256 C121.899789,-1.35984786 128.255925,-1.29519418 132.690459,4.03386336 C136.93546,9.12910484 141.210279,14.2072234 145.576617,19.4176016",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6939333,16.5778289 L30.6939333,23.6631638 L29.0584018,23.6631638 L8.8386273,23.6631638 C3.71061614,23.6631638 0.0528119872,20.0906789 0.0144330897,15.0042941 C-0.0180413621,10.4782412 0.0144330897,5.95277871 0.0144330897,1.42377358 C0.0144330897,1.04618427 0.0764297703,0.668004521 0.114808668,0.219266643 L7.09386357,0.219266643 L7.09386357,2.45705159 L7.09386357,13.5249352 C7.09386357,15.6331176 8.05038379,16.5689722 10.1759843,16.5716292 C16.4228879,16.5837333 22.6706772,16.5837333 28.9196474,16.5716292 L30.6939333,16.5778289 Z",
    id: "Fill-10"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLava);
export default __webpack_public_path__ + "static/media/lava.d7d273a685bacf86b9e73e322649dfc5.svg";
export { ForwardRef as ReactComponent };